import Vue from "vue";
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './locales';
import moment from 'moment-timezone';
import api from './services/api';
import { abilitiesPlugin } from '@casl/vue';
import { Can } from '@casl/vue';
import { Ability } from '@casl/ability';
import notify from './services/notifications';
import { createForUser } from '@license-manager/casl-rules';
import { TextHelpersPlugin } from './plugins/textHelpers';

import VueTippy, { TippyComponent } from 'vue-tippy';
import { Buffer } from 'buffer';

// @ts-ignore
window.Buffer = Buffer;

require('moment/locale/de');

// polyfill
require('blueimp-canvas-to-blob');

Vue.config.productionTip = false;

Vue.use(require('vue-moment'), { moment });

// CASL
const ability = createForUser({});

Vue.use(abilitiesPlugin, ability);

Vue.use(VueTippy);
Vue.component('tippy', TippyComponent);

Vue.use(TextHelpersPlugin);

Vue.prototype.$http = api;
Vue.prototype.$notify = notify;
Vue.component('Can', Can);

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
